import { useResolvedLabel } from '../../../../hooks/useResolvedLabel';

interface HeaderLabelProps {
  label: string;
}

const HeaderLabel = ({ label }: HeaderLabelProps) => {
  const resolvedLabel = useResolvedLabel(label);

  return (
    <div className="header-label-container">
      <h1>{resolvedLabel}</h1>
    </div>
  );
};

export default HeaderLabel;
